import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from '../interfaces/item';

@Injectable({
  providedIn: 'root'
})
export class EditItemService {

  constructor(private http:HttpClient) { }

  getItem(id:string):Observable<any>{
    return this.http.get('https://ph.eyegorithm.com/api/add-drug/'+id);
  }

  update(id:string, formData: any):Observable<any>{
    return this.http.post('https://ph.eyegorithm.com/api/add-drug/'+id, formData)
  }
}
